import { Routes, Route } from "react-router-dom";
import AffiliatorList from "../pages/Affiliator/AffiliatorList";
import WithdrawalList from "../pages/Affiliator/WithdrawalList";

const AffiliatorRoute = () => {
    return (
        <Routes>
            <Route path="/" element={<AffiliatorList />} />
            <Route path="/withdrawals" element={<WithdrawalList />} />
        </Routes>
    );
};

export default AffiliatorRoute;
